export default function (value, useRaw = false) {
  if (Number.isNaN(value)) {
    return useRaw ? value : '';
  }

  if (!Number.isFinite(value)) {
    return useRaw ? value : '';
  }

  return value.toFixed(2) + '%';
};
